import { BriefingSortByEnum } from '../enums/briefing-sort-by.enum';


export const getBriefingSortByOptions = () => {
    return [
        {
            label: 'Briefings.input.sortMentionsBy.publishedDateNewest',
            value: BriefingSortByEnum.PUBLISHED_DATE_NEWEST
        },
        {
            label: 'Briefings.input.sortMentionsBy.publishedDateOldest',
            value: BriefingSortByEnum.PUBLISHED_DATE_OLDEST
        },
        {
            label: 'Briefings.input.sortMentionsBy.sentiment',
            value: BriefingSortByEnum.SENTIMENT
        },
        {
            label: 'Briefings.input.sortMentionsBy.headline',
            value: BriefingSortByEnum.TITLE
        },
        // @TODO: We don't have tags yet, but we will bring this back when we do
        // {
        //     label: 'Briefings.input.sortMentionsBy.tags',
        //     value: BriefingSortByEnum.TAGS
        // },
        {
            label: 'Briefings.input.sortMentionsBy.author',
            value: BriefingSortByEnum.AUTHOR
        },
        {
            label: 'Briefings.input.sortMentionsBy.mediaType',
            value: BriefingSortByEnum.MEDIA_TYPE
        },
        {
            label: 'Briefings.input.sortMentionsBy.audienceMost',
            value: BriefingSortByEnum.POTENTIAL_AUDIENCE_MOST
        },
        {
            label: 'Briefings.input.sortMentionsBy.audienceLeast',
            value: BriefingSortByEnum.POTENTIAL_AUDIENCE_LEAST
        },
        {
            label: 'Briefings.input.sortMentionsBy.domainAuthority',
            value: BriefingSortByEnum.DOMAIN_AUTHORITY
        },
    ];
};

export const getAutomaticBlockSortOptions = () => {
    return [
        {
            label: 'Briefings.input.sortMentionsBy.publishedDateNewest',
            value: BriefingSortByEnum.PUBLISHED_DATE_NEWEST
        },
        {
            label: 'Briefings.input.sortMentionsBy.publishedDateOldest',
            value: BriefingSortByEnum.PUBLISHED_DATE_OLDEST
        },
        {
            label: 'Briefings.input.sortMentionsBy.audienceMost',
            value: BriefingSortByEnum.POTENTIAL_AUDIENCE_MOST
        },
        {
            label: 'Briefings.input.sortMentionsBy.audienceLeast',
            value: BriefingSortByEnum.POTENTIAL_AUDIENCE_LEAST
        },
        {
            label: 'Briefings.input.sortMentionsBy.domainAuthorityMost',
            value: BriefingSortByEnum.DOMAIN_AUTHORITY
        }
    ];
};
